// Vista productos y subcategorías
import React from 'react';
import API from '../../configAPI';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import ProductItem from '../product/ProductItem';
import PulseLoader from 'react-spinners/PulseLoader';
import {Link} from 'react-router-dom';
import CONFIG from '../../config';

class ProdutsList extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            category: {
                sub_categories: [],
                item :{}
            },
            products : {
                data: [],
                current_page: 1,
                total: 0,
                last_page: 1
            },
            loading: true,
            title_app: 'Productos',
            is_filtered: false,
            listaCarrito : [],
            loader : true
        }
    }

    componentDidMount(){
        this.getProducts();
        this.getSubcategoriesByCategory();
        window.scrollTo(0,0);
    }
    componentDidUpdate(prevProps){
        if(this.props.match.params.subcate !== prevProps.match.params.subcate){
            this.getProducts();
            window.scrollTo(0,0);
        }

    }
    
    getProducts = () =>{
        this.setState({
            loading: true
            
        });
        API.PRODUCTS(`products?slug=${this.props.match.params.subcate}&page=${this.state.products.current_page}`)
        .then(resp =>{
            this.setState({
                products : resp.data,
                loading : false,
                is_filtered: false,
                title_app : 'Productos',
                
            });
            console.log(resp.data);
        })
        .catch(err => {
            console.log(err);
        });
        
    }
    getSubcategoriesByCategory = () =>{
        API.PRODUCTS(`sub-categories/category/${this.props.match.params.category}`)
        .then(resp =>{
            this.setState({
                category : resp.data
            });
        })
        .catch(err =>{
            console.log(err);
        });
    }
    onChanhePage = async(page) =>{
        await this.setState({
            products : {
                ...this.state.products,
                current_page : page
            },
            loading : !this.state.loading
        });

        this.getProducts();
    }
    render(){
        
        return(
            <div className="container-fluid mt-3 mb-3">
                <div className="col-12">

                    <PulseLoader
                        css={CONFIG.spinner_css}
                        size={CONFIG.spinner_size}
                        margin={CONFIG.spinner_margin}
                        color={CONFIG.spinner_color}
                        loading={this.state.loading}
                    />
                    <div className="row mt-2 mb-2 d-flex flex-wrap">
                        <div className="col-xs-12 col-md-3 mt-1 mb-1">
                            <div className="list-group">
                                <li className="list-group-item secondary bg-black">{this.state.category.name}</li>
                                {this.state.category.sub_categories.map((subcate,index) =>(
                                    subcate.products_count > 0 &&
                                    <Link to={`/productos/${this.state.category.item.slug}/${this.state.category.slug}/${subcate.slug}/`} key={index} className={`list-group-item d-flex justify-content-between align-items-center list-group-item-action item-menu ${this.props.match.params.subcate === subcate.slug ? 'active': ''}`}>
                                        {subcate.name} <span className="badge badge-secondary">{subcate.products_count}</span>
                                    </Link>
                                    
                                ))}
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-9 mt-1 mb-1">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb row">
                                        <li className="breadcrumb-item" aria-current="page">
                                            <Link to={`/productos/${this.state.category.item.slug}`} >{this.state.category.item.name}</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            <Link to={`/productos/${this.state.category.item.slug}/${this.state.category.slug}`}>{this.state.category.name}</Link>
                                            
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                        <span className="badge badge-secondary">{this.state.products.total}</span> {this.state.title_app}
                                        {this.state.is_filtered ? 
                                        <button onClick={this.getProducts} className="btn btn-outline-success btn-sm float-right">Quitar filtros 
                                        <i className="fas fa-filter"></i></button>
                                        : ''
                                        }
                                        </li>  
                                </ol>
                            </nav>
                            <div className="mt-3 d-flex justify-content-center">
                                {this.state.products.last_page > 1 &&
                                    <Pagination 
                                        onChange={this.onChanhePage}
                                        current={this.state.products.current_page}
                                        total={this.state.products.total}
                                        showTitle={false}
                                        defaultPageSize={this.state.products.to}
                                    />
                                }
                            </div>
                            <div className="row d-flex flex-wrap mt-1">
                                
                            {this.state.products.total > 0 ? <ProductItem products={this.state.products.data}/> : 'Sin resultados'}
                                
                            </div>
                            <div className="mt-3 d-flex justify-content-center">
                                {this.state.products.last_page > 1 &&
                                    <Pagination 
                                        onChange={this.onChanhePage}
                                        current={this.state.products.current_page}
                                        total={this.state.products.total}
                                        showTitle={false}
                                        defaultPageSize={this.state.products.to}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
 
}
export default ProdutsList;